// extracted by mini-css-extract-plugin
module.exports = {"icon":"AssetType-module--icon--1Qcdu","typeLabel":"AssetType-module--typeLabel--1B7iT"};